import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

// Thunks
export const getClientSecurities = createAsyncThunk(
  "clientPortfolio/getSecurities",
  async (clientId, { rejectWithValue }) => {
    try {
      const res = await getMethod(`/profileSummary/getSecuritiesByClientId/${clientId}`);
      const data = await res.json();
      return data?.data || [];
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Error fetching securities");
    }
  }
);


export const getClientInvestments = createAsyncThunk(
  "clientPortfolio/getInvestments",
  async (clientId, { rejectWithValue }) => {
    try {
      const res = await getMethod(`/profileSummary/getInvestmentsByClientId/${clientId}`);
      const data = await res.json();
      return data?.data || [];
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Error fetching investments");
    }
  }
);
export const getClientDocumentsByAccount = createAsyncThunk(
  "documents/getClientDocumentsByAccount",
  async (
    { master_id, property_id, encodedownerId, clientsId, categories, page = 1, limit = 100, startDate, endDate },
    { rejectWithValue }
  ) => {
    try {
      const queryParams = new URLSearchParams();

      if (master_id) {
        queryParams.append("account_type", master_id);
      }

      if (property_id) {
        queryParams.append("account", property_id);
      }

      if (encodedownerId) {
        queryParams.append("ownerEntity", encodedownerId);
      }

      if (clientsId) {
        queryParams.append("clientId", clientsId);
      }
      if (categories?.length) {
        queryParams.append("categoryId", categories.join(","));
      }
      if (startDate) {
        queryParams.append("startDate", startDate);
      }
      if (endDate) {
        queryParams.append("endDate", endDate);
      }

      queryParams.append("page", page);
      queryParams.append("limit", limit);

      const response = await getMethod(
        `/api/getAllDocuments?${queryParams.toString()}`
      );

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching client documents by account:", error);
      return rejectWithValue(
        error?.message || "Failed to fetch client documents"
      );
    }
  }
);


export const getClientDocumentsByAccountType = createAsyncThunk(
  "documents/getDocumentsByAccountType",
  async ({ clientsId, advisorId, rootId }, { rejectWithValue }) => {
    try {
      let response;
      if (advisorId) {
        response = await getMethod(
          `/api/client/${clientsId}/documents?page=1&limit=10&accountType=${rootId}&advisorId=${advisorId}`
        );
      } else {
        response = await getMethod(
          `/api/client/${clientsId}/documents?page=1&limit=10&accountType=${rootId}`
        );
      }
      const data = await response.json();
      return data?.data;
    } catch (error) {

      return rejectWithValue(error?.message || "Failed to fetch documents");
    }
  }
);

const clientPortfolioSlice = createSlice({
  name: "clientDocument",
  initialState: {
    clientSecurities: [],
    clientInvestments: [],
    clientdocuments: [],
    clientPerformacePagination: {},
    loadingSecurities: false,
    loadingInvestments: false,
    errorSecurities: null,
    errorInvestments: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Securities cases
    builder
      .addCase(getClientSecurities.pending, (state) => {
        state.loadingSecurities = true;
        state.errorSecurities = null;
      })
      .addCase(getClientSecurities.fulfilled, (state, action) => {
        state.loadingSecurities = false;
        state.clientSecurities = action.payload || [];
      })
      .addCase(getClientSecurities.rejected, (state, action) => {
        state.loadingSecurities = false;
        state.errorSecurities = action.payload;
      });

    // Investments cases
    builder
      .addCase(getClientInvestments.pending, (state) => {
        state.loadingInvestments = true;
        state.errorInvestments = null;
      })
      .addCase(getClientInvestments.fulfilled, (state, action) => {
        state.loadingInvestments = false;
        state.clientInvestments = action.payload || [];
      })
      .addCase(getClientInvestments.rejected, (state, action) => {
        state.loadingInvestments = false;
        state.errorInvestments = action.payload;
      });

    builder
      .addCase(getClientDocumentsByAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClientDocumentsByAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.clientdocuments = action.payload?.data;
        state.clientPerformacePagination = action.payload?.pagination;
      })
      .addCase(getClientDocumentsByAccount.rejected, (state, action) => {
        state.loading = false;
        state.clientPerformacePagination = {}
        state.error = action.payload || "Failed to fetch documents";
      });
    builder
      .addCase(getClientDocumentsByAccountType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClientDocumentsByAccountType.fulfilled, (state, action) => {
        state.loading = false;
        state.clientdocuments = action.payload;
      })
      .addCase(getClientDocumentsByAccountType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch documents";
      });
  },
});

export default clientPortfolioSlice.reducer;
